import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Api } from "../../../utils/Variables";

const CategoriesMenu = (props) => {
  const [categories, setCategories] = useState([]);

  // Load categories from the API and filter out Saree and Lehenga
  const loadCategories = () => {
    axios.get(`${Api.Url}v1/site/categorylist/4`).then((res) => {
      if (res.data.status === "1") {
        const filtered = res.data.data.filter(
          (cat) =>
            cat.categoryname.toLowerCase() !== "saree" &&
            cat.categoryname.toLowerCase() !== "lehenga"
        );
        setCategories(filtered);
      }
    });
  };

  useEffect(() => {
    loadCategories();
  }, []);

  // Main categories with subcategories
  const mainCategories = () => {
    return categories.map((item, i) => {
      return (
        item.subcategory &&
        item.subcategory.length > 0 && (
          <div key={i}>
            <h6
              className="text-start"
              style={{ fontSize: "13px", marginLeft: "25px" }}
            >
              {item.categoryname}
            </h6>
            <ul
              className="text-start"
              style={{ fontSize: "12px", marginLeft: "35px" }}
            >
              {singleCategory(item.subcategory)}
            </ul>
          </div>
        )
      );
    });
  };

  // Subcategory items
  const singleCategory = (items) => {
    return items.map((item, i) => (
      <li key={i}>
        <Link to={`/category/${item.slug}`} onClick={() => props.menuClick()}>
          {item.categoryname}
        </Link>
      </li>
    ));
  };

  return <div>{mainCategories()}</div>;
};

export default CategoriesMenu;
